import { type FunctionComponent, useEffect, useState } from "react";
import {
  HomepageThemeFindOutMoreDisplay,
  HomepageThemeSignUpButtonDisplay,
  NewsletterVariant,
  useNewsletterApi,
  useSignedUpNewsletter,
} from "scmp-sdk";
import type { NewsletterItem } from "scmp-sdk/components/newsletter/types";

import type { NewsletterPackageDetail, ValidNewsletterPackageKey } from "shared/data/newsletter";
import { notEmpty } from "shared/lib/utils";

import { getNextNewsletterPackage } from "scmp-app/components/newsletter/helpers";
import { NewsletterWidgetContainer } from "scmp-app/components/newsletter/newsletter-widget-container";

export type Props = {
  className?: string;
};

export const LiveNewsletterWidget: FunctionComponent<Props> = ({ className }) => {
  const subscribedPackageIds = useSignedUpNewsletter();
  const { fetchNewsletterByIds, isNewslettersDataReady } = useNewsletterApi();

  const [packageKey, setPackageKey] = useState<ValidNewsletterPackageKey>();
  const [selectedPackage, setSelectedPackage] = useState<NewsletterPackageDetail>();
  const [childNewsletterItems, setChildNewsletterItems] = useState<NewsletterItem[]>();

  useEffect(() => {
    void (async () => {
      const packageToShow = await getNextNewsletterPackage("Live", subscribedPackageIds);
      const packageDetail = packageToShow?.packageDetail;
      setSelectedPackage(packageDetail);
      setPackageKey(packageToShow?.packageKey);

      if (notEmpty(packageDetail?.childNewsletterIds)) {
        const data = await fetchNewsletterByIds(
          packageDetail?.childNewsletterIds,
          packageDetail?.childNewsletterIds.length,
        );
        setChildNewsletterItems(data?.filter(notEmpty) ?? []);
        return;
      }
      setChildNewsletterItems([]);
    })();
  }, [fetchNewsletterByIds, subscribedPackageIds]);

  if (!isNewslettersDataReady && childNewsletterItems === undefined) return null;

  return (
    <NewsletterWidgetContainer
      className={className}
      findOutMoreButtonDisplayComponent={<HomepageThemeFindOutMoreDisplay />}
      multipleNewsletters
      newsletterItems={childNewsletterItems ?? []}
      packageDisplayName={selectedPackage?.packageDisplayName}
      packageKey={packageKey}
      signUpButtonDisplayComponent={<HomepageThemeSignUpButtonDisplay />}
      useOnlyPackageNewsletters
      variant={NewsletterVariant.Section}
    />
  );
};

LiveNewsletterWidget.displayName = "LiveNewsletterWidget";
